import ApiService from '../libs/ApiService.js'

let MeStore = {
    //force using `me` namespace
    namespaced: true,
    state: {
        user: null,
        //when the app loaded we want to check against the server
        initialized: false
    },
    getters: {
        isLoggedIn(state) {
            try {
                return !!state.user.api_key;
            } catch (e) {
                return false;
            }
        },
        isInitialized(state) {
            return !!state.initialized;
        }
    },
    mutations: {
        setUser(state, data) {
            state.user = data
        },
        setInitialize(state) {
            state.initialized = true;
        }
    },
    actions: {
        async loadFromServer({commit}) {
            try {
                //get the data from the reponse object
                let {data} = await ApiService.get('/private/me');
                commit('setUser', data);
                //if we got data set the flag as initilized (not need to reload from server)
                if (data) {
                    commit('setInitialize');
                }
            } catch (e) {
                console.error(e.message);
            }
        },
        logout({commit}) {
            //do not wait here...
            ApiService.post('/auth/logout');
            //set as null
            commit('setUser', null);

        }
    },
    modules: {}
};

export default MeStore;